module.exports = __webpack_public_path__ + "img/logo@3x.f3d891b6.png";